// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAsMhlSjDt292Khj8OWXCaOGJLj_2rdZg",
  authDomain: "trillionstock-e9b0f.firebaseapp.com",
  projectId: "trillionstock-e9b0f",
  storageBucket: "trillionstock-e9b0f.firebasestorage.app",
  messagingSenderId: "440078664837",
  appId: "1:440078664837:web:49eb1571fb42eb562915ec",
  measurementId: "G-P9J6YRVKMP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { db, auth, analytics };
export default app;

